"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classNames_1 = require("../../../../../utils/classNames");
const Heading = ({ as = 'h1', children, className }) => {
    const Heading = (props) => (0, react_1.createElement)(as, props, children);
    return ((0, jsx_runtime_1.jsx)(Heading, { className: (0, classNames_1.cn)('font-["Akshar"] font-bold', className), children: children }));
};
exports.Heading = Heading;
